import { API_BASE_URL } from "../urls.api";

export const GET_PRODUCTS_URL = `${API_BASE_URL}/products`;

export const getUpdateProductUrl = (hubspotId: string) =>
  `${API_BASE_URL}/products/hubspot/${hubspotId}`;
